import React, { useEffect, useState } from 'react';
import {
  Box, Paper, Typography, Button, CircularProgress
} from '@mui/material';
import { Security } from '@mui/icons-material';

const DIFC_COLORS = {
  primary: '#003366',
  secondary: '#00796B',
  accent: '#FFC72C',
  background: '#F5F8FA',
  textPrimary: '#1E2D3B',
  textSecondary: '#4A6B82',
};

function LoginPage({ onLogin, redirectTo = '/prediction' }) {
  const [checking, setChecking] = useState(true);

  // If already authenticated, skip the login screen
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch('/.auth/me', { credentials: 'include' });
        if (res.ok) {
          const data = await res.json();
          const user = data?.clientPrincipal;
          if (user && user.userRoles?.includes('authenticated')) {
            onLogin?.(user);
            window.location.replace(redirectTo);
            return;
          }
        }
      } catch (_) {}
      setChecking(false);
    })();
  }, [onLogin, redirectTo]);

  const handleMicrosoftSignIn = () => {
    
    const postLogin = encodeURIComponent(`${window.location.origin}${redirectTo}`);
    window.location.href = `/.auth/login/aad?post_login_redirect_uri=${postLogin}`;
  };

  if (checking) {
    return (
      <Box
        sx={{
          minHeight: '100vh', display: 'flex', alignItems: 'center',
          justifyContent: 'center', backgroundColor: DIFC_COLORS.background
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: DIFC_COLORS.background,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      }}
    >
      <Paper
        elevation={8}
        sx={{
          p: 4, maxWidth: 420, width: '100%', mx: 2, borderRadius: 3, backgroundColor: 'white',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Security sx={{ fontSize: 48, color: DIFC_COLORS.primary, mb: 2 }} />
          <Typography variant="h4" sx={{ fontWeight: 600, color: DIFC_COLORS.textPrimary, mb: 1 }}>
            Sign in
          </Typography>
          <Typography variant="body2" sx={{ color: DIFC_COLORS.textSecondary }}>
            DIFC Occupancy Optimization System
          </Typography>
        </Box>

        <Button
          fullWidth
          variant="contained"
          onClick={handleMicrosoftSignIn}
          sx={{
            py: 1.5, fontWeight: 600, fontSize: '1rem', textTransform: 'none',
            borderRadius: 2, backgroundColor: DIFC_COLORS.primary,
            '&:hover': { backgroundColor: DIFC_COLORS.secondary },
          }}
        >
          Sign in with Microsoft
        </Button>
      </Paper>
    </Box>
  );
}

export default LoginPage;

